import React from 'react';
import './photoslide.css'

const Photoslide  = (props) => {
    return ( 
        <img className= {props.selectedphoto} src={props.img11} alt="" />
     );
}
 
export default Photoslide ;